module.exports = __webpack_public_path__ + "img/AC.4e2b91bf.png";